import { render, staticRenderFns } from "./Interest.vue?vue&type=template&id=1cf65689&scoped=true&"
import script from "./Interest.vue?vue&type=script&lang=js&"
export * from "./Interest.vue?vue&type=script&lang=js&"
import style0 from "./Interest.vue?vue&type=style&index=0&id=1cf65689&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf65689",
  null
  
)

export default component.exports